import { ICompanyType } from '@company/companyType/companyType.models';
import { IOrganizationTypeOption } from '@company/organizationType/organizationType.models';
import { IOption } from '@gcl/react-core';
import { IRiskCategory } from '@riskCategory/riskCategory.models';

export enum ECompanyFormKeys {
  TYPE = 'companyType',
  TYPE_ID = 'companyTypeId',
  NAME = 'name',
  CODE = 'code',
  ORGANIZATION_TYPE = 'OrganizationType',
  ORGANIZATION_TYPE_ID = 'OrganizationTypeId',
  MAX_RISK_CATEGORY = 'MaxRiskCategory',
}

export enum ECompanyFormType {
  PROJECT_REQUEST,
  USERS,
}

export interface ICompanyFormState {
  [ECompanyFormKeys.CODE]: string | null;
  [ECompanyFormKeys.NAME]: string | null;
  [ECompanyFormKeys.MAX_RISK_CATEGORY]: IOption<IRiskCategory> | null;
  [ECompanyFormKeys.TYPE]: IOption<ICompanyType> | null;
  [ECompanyFormKeys.ORGANIZATION_TYPE]: IOption<IOrganizationTypeOption>[] | null;
}
